import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';


// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import Clear from "@material-ui/icons/Clear";
import Check from "@material-ui/icons/Check";

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import datePickerStyle from "../../../assets/jss/material-kit-pro-react/components/datePickerStyle.jsx";

const DatePicker = class extends React.Component {
    render(){
        const {
            classes,
            formControlProps,
            labelText,
            inputProps,
            error,
            success,
            format,
            variant,
            disableFuture
        } = this.props;
        let { value, id } = this.props;

        if(id === null){
            id = "date-picker-dialog";
        }
        if(typeof(value) === "string" && value.length <= 0){
            value = null;
        }
        var formControlClasses;
        if (formControlProps !== undefined) {
            formControlClasses = classNames(
                formControlProps.className,
                classes.formControl
            );
        } else {
            formControlClasses = classes.formControl;
        }
        return(
            <FormControl {...formControlProps} className={"datePickerFormControl "+formControlClasses}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>                    
                    <KeyboardDatePicker
                        id={id}
                        onChange={this.props.onChange}
                        format={format}
                        value={value}
                        // success={success}
                        // error={error}
                        label={labelText}
                        variant={variant}
                        disableFuture={disableFuture}
                        KeyboardButtonProps={{
                            'aria-label': 'change date',
                            'className': (inputProps.disabled ? classes.buttonDisabled : '')
                        }}
                        disabled={(inputProps.disabled ? true : false)}
                        InputProps={inputProps}
                        DialogProps={{
                            className: classes.modalRoot,
                        }}
                    />
                </MuiPickersUtilsProvider>
                {error ? (
                    <Clear className={classes.feedback + " " + classes.labelRootError} />
                ) : success ? (
                    <Check className={classes.feedback + " " + classes.labelRootSuccess} />
                ) : null }
            </FormControl>
        )
    }
}

DatePicker.defaultProps = {
    loading: false,
    id: null,
    onChange: function(){ },
    labelText: "Date Picker",
    format: "MM-dd-yyyy",
    value: null,
    variant: "dialog",
    inputProps:{
        autoComplete: "off"
    },
    disableFuture: false,
    color: "primary"
}

DatePicker.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.string,
    labelText: PropTypes.node,
    labelProps: PropTypes.object,
    inputProps: PropTypes.object,
    formControlProps: PropTypes.object,
    inputRootCustomClasses: PropTypes.string,
    onChange: PropTypes.func,
    format: PropTypes.string,
    value: PropTypes.string,
    disableFuture: PropTypes.bool,
    variant: PropTypes.oneOf([
        "dialog",
        "inline",
        "static"
    ]),
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "gray",
        "rose",
        "customInfo",
        "customSuccess",
        "customRose",
    ]),
};
  
export default withStyles(datePickerStyle)(DatePicker);